<!-- <ng-container *ngIf="theme === 'red'; else blueTheme"> -->
<ng-container>
  <div class="profile-notice-container" [ngClass]="{'acmic-them-color':isAcmic}">
    <section class="pf-ntc-cntx" [ngClass]="theme">
      <div class="left-notice" *ngIf="theme === 'blue'">
        <img src="./assets/img/images/icon-info-blue.svg" alt="info icon" />
      </div>
      <div class="right-notice">
        <div class="title mb-2 font-weight-500 dm-sans-medium" *ngIf="notificationMsg && notificationMsg.title">
          {{ notificationMsg.title }}
        </div>
        <div class="para dm-sans-medium" *ngIf="notificationMsg && notificationMsg.textOne">
          {{ notificationMsg.textOne }}
        </div>
        <div class="para dm-sans-medium mt-3" *ngIf="notificationMsg && notificationMsg.textTwo">
          {{ notificationMsg.textTwo }}
        </div>
        <!-- <div class="para dm-sans-medium mt-3" *ngIf="notificationMsg && notificationMsg.textThree">
          {{ notificationMsg.textThree }}
        </div> -->
      </div>
      <div class="close-icon">
        <img src="./assets/img/images/icon-close-18.svg" alt="close icon" (click)="onClose()" />
      </div>
    </section>
  </div>
</ng-container>

<!-- <div class="left-notice" *ngIf="theme === 'red'">
  <img src="./assets/img/images/icon-warning-red.svg" alt="info icon" />
</div> -->